import { Injectable, NgZone } from '@angular/core';
import { HttpHelper } from './http.service';
import { AppConfig } from '../model/config';
import { Message } from '../model/message';
import { List } from 'immutable';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs-compat';
import { ToastrService } from 'ngx-toastr';
import { SignalRService } from './signalr.service';
import { async } from 'rxjs/internal/scheduler/async';

@Injectable()
export class DispatcherService {

  private readonly messages: BehaviorSubject<List<Message>> = new BehaviorSubject(List([]));
  public readonly Messages: Observable<List<Message>> = this.messages.asObservable();

  private readonly unreadCount: BehaviorSubject<number> = new BehaviorSubject(0);
  public readonly UnreadCount: Observable<number> = this.unreadCount.asObservable();

  private readonly backendUrl: string;

  constructor(
    private readonly configuration: AppConfig,
    private readonly http: HttpHelper,
    private readonly toastr: ToastrService,
    private readonly zone: NgZone,
    private readonly signalRService: SignalRService) {

    this.backendUrl = this.configuration.backendUrl;

    this.signalRService.updateDispatchStatus$.subscribe((message: string) => { this.onUpdateMessage(message); });

  }

  public async updateMessage(status: string): Promise<any> {

    return this.http.post(this.configuration.backendUrl + "/api/dispatch/", JSON.stringify(status),
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  public async getStatus(): Promise<any> {
    return this.http.get(this.configuration.backendUrl + "/api/dispatch/",
      (result) => { },
      (exception) => { }).toPromise<any>();
  }

  private onUpdateMessage(string: string) {
    console.log("updateMessage");
  }

 
}

